import { SliceZone } from '@prismicio/react';
import Head from 'next/head';
import { useRef } from 'react';
import { DocumentHead } from 'remote-com-shared/components/DocumentHead';
import { Wrapper as MenuWrapper } from 'remote-com-shared/components/HeaderNavigation/styles/Wrapper';
import { staticAssetUrl } from 'remote-com-shared/domains/assets/helpers';
import smoothscroll from 'smoothscroll-polyfill';
import styled from 'styled-components';

import { AlternatingContentImageSlice } from '../Slices/AlternatingContentImageSlice';
import { CustomPrimaryCTASlice } from '../Slices/CustomPrimaryCTASlice';
import { FeaturesSectionSlice } from '../Slices/FeaturesSectionSlice';
import { HeroSlice } from '../Slices/HeroSlice';
import { ImageAndDescriptionSlice } from '../Slices/ImageAndDescriptionSlice';
import { PartnersLogoSlice } from '../Slices/PartnersLogoSlice';
import { StatsSectionSlice } from '../Slices/StatsSectionSlice';

import { FooterOnlyLayout } from '@/layouts/FooterOnly';
import { QuoteSlice } from '@/src/views/SwitchToRemote/QuoteSlice';

if (typeof window !== 'undefined') {
  smoothscroll.polyfill();
}

const SliceWrapper = styled.div`
  --color-tone-primary: #e03d5c;
  --color-tone-secondary: #fef7f9;
  --color-tone-secondary-background: #fcf0f3;
  --color-tone-secondary-shadow: rgba(7, 60, 37, 0.3);
  --color-tone-font: #360f16;

  font-family: var(--typography-fontBrand);

  ${MenuWrapper} {
    --menuInteractionHighlightBorderColor: var(--color-tone-primary);
  }
`;

export function PaidContractorFairpricingView(document) {
  const { body, header_navigation_items: headerNavigationItems, no_index: noIndex } = document;
  const applyFormRef = useRef();
  const components = {
    hero_section: HeroSlice,
    alternating_content_image: AlternatingContentImageSlice,
    client_logo_slider: PartnersLogoSlice,
    image_and_description: ImageAndDescriptionSlice,
    stats_section: StatsSectionSlice,
    feature_section: FeaturesSectionSlice,
    quote_section: QuoteSlice,
    primary_cta: CustomPrimaryCTASlice,
  };

  return (
    <>
      <DocumentHead document={document} noIndex={noIndex} />
      <Head>
        <link rel="stylesheet" href={staticAssetUrl('/fonts/import-remote-sans.css')} />
        <link rel="stylesheet" href={staticAssetUrl('/fonts/import-bossa.css')} />
      </Head>
      <SliceWrapper>
        <SliceZone
          slices={body}
          components={components}
          context={{ applyFormRef, headerNavigationItems }}
        />
      </SliceWrapper>
    </>
  );
}

PaidContractorFairpricingView.Layout = FooterOnlyLayout;
